import { EActiveView } from '../../types/view';
import { ESendSmsStatus } from '../../types/registration';
import { ESentEmailType } from '../../types/sentEmail';
import { REGISTRATION_SEND_SMS_TYPE } from '../../constants/action_types';
import { sendSms as sendSmsApi } from '../../api/sendSms';
import { changeView } from '../view';
export function sendSms(_ref) {
  var email = _ref.email,
    phone = _ref.phone;
  return function (dispatch, _getState, context) {
    dispatch({
      status: ESendSmsStatus.Loading,
      type: REGISTRATION_SEND_SMS_TYPE
    });
    return sendSmsApi(context.httpApi, {
      validationType: 'PhoneNumber',
      email: email,
      phone: phone
    }).then(function (response) {
      if (response.statusCode === 200 && response.response.success) {
        dispatch({
          status: ESendSmsStatus.Succeed,
          type: REGISTRATION_SEND_SMS_TYPE
        });
        dispatch(changeView(EActiveView.ConfirmPhone, {
          email: email,
          phone: phone
        }));
        return;
      }
      dispatch({
        status: ESendSmsStatus.Failed,
        type: REGISTRATION_SEND_SMS_TYPE,
        error: 'Не удалось отправить проверочный код'
      });
      dispatch(changeView(EActiveView.EmailSent, {
        type: ESentEmailType.Registration
      }));
    }).catch(function (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.sendSms'
      });
      dispatch({
        status: ESendSmsStatus.Failed,
        type: REGISTRATION_SEND_SMS_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}